import { apiFetch } from "@/lib/api";

export type SessionExchangeResponse = {
  ok: boolean;
  username: string;
  role: string;
  roles: string[];
};

/** Mirror the active first-party Kratos session into Tktic's own app
 * session (`tktic_session` + `tktic_csrf` cookies). Call after any
 * completed Kratos ceremony — login, registration + verification,
 * recovery. The backend enforces verified email and account status.
 *
 * Rejects with `403 {code:"mfa_login_required"}` when the user's
 * MFA-at-login preference is armed and the Kratos session is still
 * first-factor-only — callers surface the second-factor step inline.
 * `rememberDevice` asks the backend to trust this browser for 30 days
 * (honored only when the Kratos session is aal2). */
export function exchangeKratosSession(options?: {
  rememberDevice?: boolean;
}): Promise<SessionExchangeResponse> {
  return apiFetch<SessionExchangeResponse>("/api/auth/session/exchange", {
    method: "POST",
    scope: false,
    ...(options?.rememberDevice ? { body: { remember_device: true } } : {}),
  });
}

export function linkKratosSocialSession(
  password: string,
): Promise<SessionExchangeResponse> {
  return apiFetch<SessionExchangeResponse>("/api/auth/session/link-social", {
    method: "POST",
    body: { password },
    scope: false,
  });
}
